import React from 'react';

const LEVEL_COLORS = {
  NOMINAL: '#00E5FF',
  ELEVATED: '#FF9F0A',
  STORM: '#FF6B35',
  EXTREME: '#FF3B30',
};

const MON_COLORS = { LIVE: '#34C759', DEGRADED: '#FF9F0A', PARTIAL_COVERAGE: '#FF9F0A', OFFLINE: '#FF3B30' };

export default function OrionTopBar({ timestamp, signalCount, totalInsights, state, scoring, sensorReadiness, onRefresh, onSwitchAgent, onSwitchToShow, onSwitchToVega, onSwitchToAtlas, onSwitchToCrew }) {
  const levelColor = LEVEL_COLORS[state?.level] || '#00E5FF';
  const readinessState = sensorReadiness?.state;
  const monState = readinessState === 'NO_LIVE_SOURCES'
    ? 'OFFLINE'
    : readinessState === 'DEGRADED'
      ? 'PARTIAL_COVERAGE'
      : (scoring?.monitoringState || 'LIVE');
  const monColor = MON_COLORS[monState] || '#52525B';
  const confidence = scoring?.finalConfidenceScore;

  return (
    <div className="orion-topbar" data-testid="orion-topbar">
      <div className="orion-topbar-status" style={{ background: levelColor }} data-testid="orion-status-dot" />
      <div className="orion-topbar-logo" data-testid="orion-logo">ORION</div>
      <div className="orion-topbar-sep" />
      <div className="orion-topbar-sub">SPACE WEATHER INTELLIGENCE</div>
      <div className="orion-topbar-spacer" />

      {/* Monitoring state badge */}
      <div className="orion-topbar-mon" style={{ color: monColor, borderColor: `${monColor}40` }} data-testid="orion-monitoring-state">
        {monState.replace('_', ' ')}
      </div>

      {scoring?.affectedDomains?.length > 0 && (
        <div className="orion-topbar-affected" data-testid="orion-affected-strip">
          {scoring.affectedDomains.map(d => d.replace('_', ' ')).join(', ')}
        </div>
      )}

      <div className="orion-topbar-sep" />

      <div className="orion-topbar-level" style={{ color: levelColor, borderColor: `${levelColor}40` }} data-testid="orion-level-badge">
        {state?.level || 'NOMINAL'}
      </div>

      <div className="orion-topbar-metric" data-testid="orion-signal-count">
        <span className="orion-metric-val">{signalCount || 0}</span>
        <span className="orion-metric-label">SIGNALS</span>
      </div>
      <div className="orion-topbar-metric" data-testid="orion-insight-count">
        <span className="orion-metric-val">{totalInsights || 0}</span>
        <span className="orion-metric-label">INSIGHTS</span>
      </div>
      {confidence !== undefined && (
        <div className="orion-topbar-metric" data-testid="orion-confidence-score">
          <span className="orion-metric-val">{confidence.toFixed(0)}</span>
          <span className="orion-metric-label">CONF</span>
        </div>
      )}
      <div className="orion-topbar-sep" />

      <button className="orion-topbar-refresh" onClick={onRefresh} data-testid="orion-refresh-btn">REFRESH</button>
      <div className="orion-topbar-clock" data-testid="orion-clock">{timestamp}</div>
      <div className="orion-topbar-live" style={{ color: monColor, borderColor: `${monColor}30` }} data-testid="orion-live-indicator">
        {monState === 'LIVE' ? 'LIVE' : monState.replace('_', ' ')}
      </div>

      <button className="orion-switch-btn" onClick={() => onSwitchAgent('nova')} data-testid="switch-to-nova-btn">
        NOVA
      </button>
      {onSwitchToVega && <button className="orion-switch-btn" onClick={onSwitchToVega} data-testid="switch-to-vega-btn" style={{ color: '#6366F1', borderColor: '#6366F130' }}>VEGA</button>}
      {onSwitchToAtlas && <button className="orion-switch-btn" onClick={onSwitchToAtlas} data-testid="switch-to-atlas-btn" style={{ color: '#059669', borderColor: '#05966930' }}>ATLAS</button>}
      {onSwitchToCrew && <button className="orion-switch-btn" onClick={onSwitchToCrew} data-testid="switch-to-crew-btn" style={{ color: '#4de2c0', borderColor: '#4de2c040' }}>CREW</button>}
      {onSwitchToShow && <button className="orion-switch-btn" onClick={onSwitchToShow} data-testid="switch-to-show-btn" style={{ color: '#e8e8e8', borderColor: '#e8e8e830' }}>SHOW</button>}
    </div>
  );
}
